import { render, staticRenderFns } from "./IncidentView.vue?vue&type=template&id=fae389ee&"
import script from "./IncidentView.vue?vue&type=script&lang=js&"
export * from "./IncidentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports